import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

const ViewCancellationModalCPF = ({ isOpen, onClose, cancellationDetails, seriesNo }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-4 w-full max-w-sm">
        <div className="flex justify-between items-center mb-3">
          <h2 className="text-lg font-semibold text-gray-800">
            Cancellation for Series: {seriesNo}
          </h2>
          <button
            onClick={onClose}
            className="text-gray-600 hover:text-gray-800"
          >
            <FontAwesomeIcon icon={faXmark} className="h-4 w-4" />
          </button>
        </div>
        <div className="space-y-3">
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">Reason</label>
            <textarea
              readOnly
              rows={6}
              value={cancellationDetails?.reason || 'No reason provided'}
              className="w-full text-xs text-gray-600 border border-gray-200 rounded-lg p-2 bg-gray-50 resize-none"
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">Cancelled By</label>
            <p className="text-xs text-gray-600">{cancellationDetails?.cancelled_by || 'Unknown'}</p>
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">Cancelled At</label>
            <p className="text-xs text-gray-600">{cancellationDetails?.cancelled_at || 'N/A'}</p>
          </div>
        </div>
        <div className="mt-4 flex justify-end">
          <button
            onClick={onClose}
            className="px-3 py-1.5 text-xs text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewCancellationModalCPF;